import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import type { ShippingCosts } from 'server/detail-requests/ShippingCost';
import type { SpecialCampaignBannerProps } from '@sbt-web/banners';
import type { AdItem, FavCounter, Shop, ShopGoogleReviews, TrustProfileInfo, UserProfileInfo, UserAdInfo, SearchResult } from '@sbt-web/network/types';
import { Divider } from '@sbt-web/ui';
import AdInfo from '../../AdInfo';
import { FavoriteCounterWrapper, useFavoriteCounter } from '../../FavoriteCounter';
import SocialBar from '../../SocialBar';
import UserDetails from '../../UserDetails';
import { SectionProps } from './section';
import style from './style/general-info.module.scss';
export interface Props extends SectionProps {
  ad: AdItem;
  shop: Shop | null;
  shopGoogleReviews: ShopGoogleReviews | null;
  favoriteCounter: FavCounter | null;
  advertiserProfile: UserProfileInfo | null;
  shippingCosts: ShippingCosts | null;
  trustInfo: TrustProfileInfo | null;
  specialCampaignBannerData?: SpecialCampaignBannerProps | null;
  showContactButton?: boolean;
  privateUserInfo?: UserAdInfo | null;
  userAds?: SearchResult | null;
}
const GeneralInfoSection = t0 => {
  const $ = _c(32);
  const {
    classes: t1,
    ad,
    shop,
    shopGoogleReviews,
    favoriteCounter,
    advertiserProfile,
    shippingCosts,
    trustInfo,
    specialCampaignBannerData,
    showContactButton: t2,
    privateUserInfo,
    userAds
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const classes = t3;
  const showContactButton = t2 === undefined ? false : t2;
  const [value, onSaveFavorite, onUnsaveFavorite] = useFavoriteCounter(favoriteCounter?.value);
  let t4;
  if ($[2] !== classes) {
    t4 = classnames(style["general-info"], ...classes);
    $[2] = classes;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== ad || $[5] !== onSaveFavorite || $[6] !== onUnsaveFavorite) {
    t5 = <SocialBar ad={ad} onSaveFavorite={onSaveFavorite} onUnsaveFavorite={onUnsaveFavorite} />;
    $[4] = ad;
    $[5] = onSaveFavorite;
    $[6] = onUnsaveFavorite;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider classes={[style["ad-info-divider"]]} spacing="md" />;
    t7 = classnames(style["ad-info"]);
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== value) {
    t8 = <FavoriteCounterWrapper value={value} />;
    $[10] = value;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== ad || $[13] !== shippingCosts || $[14] !== specialCampaignBannerData || $[15] !== t8) {
    t9 = <div className={t7}><AdInfo item={ad} FavoriteCounter={t8} shippingCosts={shippingCosts} specialCampaignBannerData={specialCampaignBannerData} /></div>;
    $[12] = ad;
    $[13] = shippingCosts;
    $[14] = specialCampaignBannerData;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== ad.advertiser || $[18] !== ad.category.id || $[19] !== advertiserProfile || $[20] !== privateUserInfo || $[21] !== shop || $[22] !== shopGoogleReviews || $[23] !== showContactButton || $[24] !== trustInfo || $[25] !== userAds) {
    t10 = <UserDetails advertiser={ad.advertiser} shop={shop} shopGoogleReviews={shopGoogleReviews} advertiserProfile={advertiserProfile} trustInfo={trustInfo} categoryId={ad.category.id} showContactButton={showContactButton} privateUserInfo={privateUserInfo} userAds={userAds} />;
    $[17] = ad.advertiser;
    $[18] = ad.category.id;
    $[19] = advertiserProfile;
    $[20] = privateUserInfo;
    $[21] = shop;
    $[22] = shopGoogleReviews;
    $[23] = showContactButton;
    $[24] = trustInfo;
    $[25] = userAds;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t4 || $[29] !== t5 || $[30] !== t9) {
    t11 = <section className={t4}>{t5}{t6}{t9}{t10}</section>;
    $[27] = t10;
    $[28] = t4;
    $[29] = t5;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
export default GeneralInfoSection;